const n = [
  "IconAddImage",
  "IconAddToCart",
  "IconAlert",
  "IconAlertFilled",
  "IconArchive",
  "IconArrowDown",
  "IconArrowDownInCircle",
  "IconArrowDownInCircleFilled",
  "IconArrowDownLeft",
  "IconArrowDownLeftInCircle",
  "IconArrowDownLeftInCircleFilled",
  "IconArrowDownRight",
  "IconArrowDownRightInCircle",
  "IconArrowDownRightInCircleFilled",
  "IconArrowLeft",
  "IconArrowLeftInCircle",
  "IconArrowLeftInCircleFilled",
  "IconArrowRight",
  "IconArrowRightInCircle",
  "IconArrowRightInCircleFilled",
  "IconArrowUp",
  "IconArrowUpInCircle",
  "IconArrowUpInCircleFilled",
  "IconArrowUpLeft",
  "IconArrowUpLeftInCircle",
  "IconArrowUpLeftInCircleFilled",
  "IconArrowUpRight",
  "IconArrowUpRightInCircle",
  "IconArrowUpRightInCircleFilled",
  "IconAttachment",
  "IconAvatar",
  "IconAvatarFilled",
  "IconBackMarket",
  "IconBackMarketApp",
  "IconBackMarketAvatar",
  "IconBackMarketPromise",
  "IconBackMarketPromiseFilled",
  "IconBadge",
  "IconBank",
  "IconBankIn",
  "IconBankOut",
  "IconBattery",
  "IconBellAlert",
  "IconBellDisabled",
  "IconBellFilled",
  "IconBellOutlined",
  "IconBike",
  "IconBill",
  "IconBlocked",
  "IconBluetooth",
  "IconBolt",
  "IconBoltDisabled",
  "IconBoltFilled",
  "IconBurger",
  "IconCalendar",
  "IconCalendarWithCheck",
  "IconCamera",
  "IconCameraViewfinder",
  "IconCameraWithSparkle",
  "IconCardView",
  "IconCellSignal",
  "IconChargingWire",
  "IconChart",
  "IconCharter",
  "IconCheckInCircle",
  "IconCheckInCircleFilled",
  "IconCheckLarge",
  "IconCheckSmall",
  "IconCheckWithSparkles",
  "IconChevronDown",
  "IconChevronLeft",
  "IconChevronRight",
  "IconChevronUp",
  "IconCircle",
  "IconClock",
  "IconComment",
  "IconCommentPendingFilled",
  "IconCommentSolvedFilled",
  "IconCommentWithSparkles",
  "IconCompare",
  "IconCompass",
  "IconComputerMouse",
  "IconContact",
  "IconController",
  "IconCookie",
  "IconCopy",
  "IconCpu",
  "IconCreditCard",
  "IconCross",
  "IconCrosshair",
  "IconCrossInCircle",
  "IconCrossInCircleFilled",
  "IconCrossInCircleFilledSmall",
  "IconCrossSmall",
  "IconCupcake",
  "IconCurrencyAustralianDollar",
  "IconCurrencyDollar",
  "IconCurrencyEuro",
  "IconCurrencyPound",
  "IconCurrencySwedishKrone",
  "IconCurrencyYen",
  "IconCycle",
  "IconDeal",
  "IconDealFilled",
  "IconDesign",
  "IconDiamond",
  "IconDisk",
  "IconDoubleChevronSideways",
  "IconDoubleChevronUp",
  "IconDownload",
  "IconEdit",
  "IconEiffelTower",
  "IconEmojiHappy",
  "IconEmojiNeutral",
  "IconEmojiUnhappy",
  "IconEqual",
  "IconEqualInCircleFilled",
  "IconEqualizer",
  "IconEqualizerSmall",
  "IconExpand",
  "IconExport",
  "IconExpressReplacement",
  "IconExternalLink",
  "IconEyeClosed",
  "IconEyeOpen",
  "IconEyes",
  "IconFactory",
  "IconFigma",
  "IconFile",
  "IconFingerprint",
  "IconFire",
  "IconFireFilled",
  "IconFlag",
  "IconFloat",
  "IconGear",
  "IconGearUpdate",
  "IconGift",
  "IconGitHubFilled",
  "IconGlasses",
  "IconGlobe",
  "IconGoldenGate",
  "IconGpu",
  "IconGrade",
  "IconGrowth",
  "IconHdmi",
  "IconHeadset",
  "IconHeart",
  "IconHeartBroken",
  "IconHeartDiagnostic",
  "IconHeartExploded",
  "IconHeartFilled",
  "IconHistory",
  "IconHome",
  "IconHomeFilled",
  "IconImage",
  "IconImageInSquareFilled",
  "IconInboxTray",
  "IconInfo",
  "IconInfoFilled",
  "IconKeyboard",
  "IconLanguage",
  "IconLaptop",
  "IconLaptopCamera",
  "IconLeaf",
  "IconLightbulb",
  "IconListView1",
  "IconListView2",
  "IconListViewChecks",
  "IconLocationPinFilled",
  "IconLocationPinOutlined",
  "IconLockLocked",
  "IconLockUnlocked",
  "IconLogOut",
  "IconMagsafe",
  "IconMail",
  "IconMedal",
  "IconMediaPause",
  "IconMediaPlay",
  "IconMediaStop",
  "IconMegaphone",
  "IconMinus",
  "IconMinusInCircle",
  "IconMinusInCircleFilled",
  "IconMoney",
  "IconMoreHorizontal",
  "IconMoreVertical",
  "IconMove",
  "IconNewConversationFilled",
  "IconOfficial",
  "IconOfficialFilled",
  "IconPackage",
  "IconPaintBrush",
  "IconPeople",
  "IconPercentage",
  "IconPerformance",
  "IconPieChartInSquareFilled",
  "IconPlug",
  "IconPlus",
  "IconPlusInCircle",
  "IconPower",
  "IconPowerAdapterApple",
  "IconPriceTag",
  "IconPriceTagFilled",
  "IconPriceUpdate",
  "IconPrint",
  "IconProductCollection",
  "IconPromo",
  "IconQuality",
  "IconQuestionMarkInCircle",
  "IconRecommendation",
  "IconRefresh",
  "IconRefund",
  "IconRepairHome",
  "IconRepairMailIn",
  "IconRepairSelf",
  "IconRepairStore",
  "IconRocket",
  "IconScooter",
  "IconScratches",
  "IconSdhcCard",
  "IconSearch",
  "IconSearchFilled",
  "IconSearchWithSparkle",
  "IconSend",
  "IconShare",
  "IconShareAndroid",
  "IconShop",
  "IconShopFilled",
  "IconShoppingBag",
  "IconShoppingBagEmpty",
  "IconSim",
  "IconSimUnavailable",
  "IconSiren",
  "IconSmartphone",
  "IconSmartphoneBroken",
  "IconSmartphoneCamera",
  "IconSmartphoneFilled",
  "IconSmartphoneScreenSize",
  "IconSort",
  "IconSos",
  "IconSoundLow",
  "IconSoundOff",
  "IconSoundOn",
  "IconSparkles",
  "IconSparklesFilled",
  "IconSpeakerInSquareFilled",
  "IconSpinner",
  "IconSpreadsheetInSquareFilled",
  "IconStarFilled",
  "IconStarHalf",
  "IconStarOutlined",
  "IconSwap",
  "IconSwapFilled",
  "IconTablet",
  "IconTextAndImageInSquareFilled",
  "IconTextInSquareFilled",
  "IconThumbsDownFilled",
  "IconThumbsDownOutlined",
  "IconThumbsUpFilled",
  "IconThumbsUpOutlined",
  "IconTools",
  "IconTouch",
  "IconTouchbar",
  "IconTrade",
  "IconTrash",
  "IconTrophy",
  "IconTruck",
  "IconTruckExpress",
  "IconTv",
  "IconUndo",
  "IconUpload",
  "IconVideoCameraInSquareFilled",
  "IconWarning",
  "IconWatch",
  "IconWatchBand",
  "IconWaterdrop",
  "IconWifi",
  "IconZipperInSquareFilled",
  "IconReassuranceAdyen",
  "IconReassuranceArrowFilled",
  "IconReassuranceArrowOutlined",
  "IconReassuranceCalendar14Days",
  "IconReassuranceCalendar30Days",
  "IconReassuranceCertified",
  "IconReassuranceConfianza",
  "IconReassuranceCreditCardFilled",
  "IconReassuranceCreditCardOutlined",
  "IconReassuranceFevad",
  "IconReassuranceGlobeFilled",
  "IconReassuranceGlobeOutlined",
  "IconReassuranceGoogle",
  "IconReassuranceLockFilled",
  "IconReassuranceLockOutlined",
  "IconReassuranceParcelFilled",
  "IconReassuranceParcelOutlined",
  "IconReassuranceShield12Months",
  "IconReassuranceShield24Months",
  "IconReassuranceShield36Months",
  "IconReassuranceShield6Months",
  "IconReassuranceShieldFilled",
  "IconReassuranceShieldOutlined",
  "IconReassuranceSmileyFilled",
  "IconReassuranceSmileyOutlined",
  "IconReassuranceTruckFilled",
  "IconReassuranceTruckOutlined",
  "IconReassuranceTrustedShops",
  "IconSunBeam",
  "IconSunFace"
];
export {
  n as iconNames
};
